import { render, staticRenderFns } from "./attribute-upload.vue?vue&type=template&id=35c2d87d&scoped=true"
import script from "./attribute-upload.vue?vue&type=script&lang=js"
export * from "./attribute-upload.vue?vue&type=script&lang=js"
import style0 from "./attribute-upload.vue?vue&type=style&index=0&id=35c2d87d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c2d87d",
  null
  
)

export default component.exports